import type { EntityImageListItem } from "./types";

// Sort is stable, so this only ever moves a COVER-status image to the front — everything else
// keeps its relative order. Shared by the masonry gallery (grid layout) and the lightbox
// (chevron navigation) so both present images in the same order.
export function orderEntityImages(images: EntityImageListItem[]): EntityImageListItem[] {
  return [...images].sort((a, b) => (a.status === "COVER" ? -1 : b.status === "COVER" ? 1 : 0));
}
